import type { ConnectorAuth } from "@/types";

// #336 (Review-Fund): der Zusammenbau der Auth-Union aus Formularfeldern als REINE, exportierte
// Funktionen — eine Quelle für Create- UND Update-Dialog, remote UND cli-oauth. Vorher lebte
// das als Closure in den Dialogen (mit einer Inline-Kopie auf dem cli-Pfad, die die UC-2-
// Endpoints still verwarf) und war ohne Radix-Rendering nicht testbar. Hier: kein React,
// kein State — Eingabe sind die getrimmten Feld-Strings, Ausgabe ist entweder die Auth oder
// die Fehlermeldung, die der Dialog anzeigt.

export type AuthFormResult = { ok: true; auth: ConnectorAuth } | { ok: false; error: string };

export interface OAuthFormFields {
  clientId: string;
  scopes: string;
  authServerHint: string;
  authorizationEndpoint: string;
  tokenEndpoint: string;
}

export interface ClientCredentialsFormFields {
  tokenUrl: string;
  scopes: string;
  authStyle: string;
}

// Scopes werden als Freitext (Leerzeichen/Komma-getrennt) eingegeben.
export function splitScopes(raw: string): string[] {
  return raw.split(/[\s,]+/).map((s) => s.trim()).filter(Boolean);
}

// #336 (UC-2): die expliziten Endpoints sind ein PAAR — der Server lehnt Halbes ab, also hier
// schon sagen, was fehlt (statt in den 400 laufen zu lassen).
export function buildOAuthAuth(f: OAuthFormFields): AuthFormResult {
  const authEp = f.authorizationEndpoint.trim();
  const tokEp = f.tokenEndpoint.trim();
  if (Boolean(authEp) !== Boolean(tokEp)) {
    return { ok: false, error: "OAuth: Authorize- und Token-Endpoint nur gemeinsam setzen (oder beide leer lassen)" };
  }
  return {
    ok: true,
    auth: {
      kind: "oauth",
      clientId: f.clientId.trim() || null,
      scopes: splitScopes(f.scopes),
      authServerHint: f.authServerHint.trim() || null,
      authorizationEndpoint: authEp || null,
      tokenEndpoint: tokEp || null,
    },
  };
}

// #336 (UC-1): nur nicht-geheime Config; clientId/clientSecret folgen beim Verbinden
// (write-only → Vault). Unbekannter authStyle fällt auf "basic" (Server-Default) zurück.
export function buildClientCredentialsAuth(f: ClientCredentialsFormFields): AuthFormResult {
  const tokenUrl = f.tokenUrl.trim();
  if (!tokenUrl) return { ok: false, error: "Client-Credentials: Token-URL ist erforderlich" };
  return {
    ok: true,
    auth: {
      kind: "client-credentials",
      tokenUrl,
      scopes: splitScopes(f.scopes),
      authStyle: f.authStyle === "body" ? "body" : "basic",
    },
  };
}
